<template>
  <div>
    <div :class="{'c-sidebar__active-group': group === 'user'}">
      <template>
        <div class="c-sidebar__item c-sidebar__item-main c-sidebar__item-with-children
         c-sidebar__item-open">
          {{ $t('user.account') }}
        </div>
        <router-link exact
          class="c-sidebar__item"
          :to="{ name: 'user.profile'}">
          {{ $t('profile') }}
        </router-link>
        <router-link
          class="c-sidebar__item"
          :to="{ name: 'user.organisations'}">
          {{ $t('organisations') }}
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'user-menu',
    data: function() {
      return {
        group: 'user',
      }
    },
  }
</script>
